import { doLogout } from "./authAction";
import { BASE_URL } from "./constant";

export const REPORT_NILAI_BARANG_PER_PELABUHAN = "REPORT_NILAI_BARANG_PER_PELABUHAN";
export const REPORT_NILAI_BARANG_PER_PELABUHAN_URL = "report/nilai-barang-perpelabuhan";

const nilaiBarangPelabuhanLoading = () => {
    return {
        type: REPORT_NILAI_BARANG_PER_PELABUHAN + "_LOADING",
    };
};

const nilaiBarangPelabuhanError = () => {
    return {
        type: REPORT_NILAI_BARANG_PER_PELABUHAN + "_ERROR",
    };
};

const nilaiBarangPelabuhanSuccess = (payload) => {
    return {
        type: REPORT_NILAI_BARANG_PER_PELABUHAN + "_SUCCESS",
        payload: payload,
    };
};

const nilaiBarangPerPelabuhan = (params = {}) => {
    return (dispatch) => {
        let token = localStorage.getItem("tolaut@token") || null;
        let config = {};
        if (token) {
            config = {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(params),
            };
        } else {
            throw Error("Authentication error");
        }

        dispatch(nilaiBarangPelabuhanLoading());

        fetch(BASE_URL + REPORT_NILAI_BARANG_PER_PELABUHAN_URL, config)
            .then((response) => {
                if (response.status === 401) {
                    dispatch(doLogout());
                }
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 200) {
                    dispatch(nilaiBarangPelabuhanSuccess(data));
                } else {
                    dispatch(nilaiBarangPelabuhanError());
                }
            })
            .catch((err) => {
                dispatch(nilaiBarangPelabuhanError());
            });
    };
};

export default nilaiBarangPerPelabuhan;
